import PropTypes from 'prop-types'
import React from 'react'
import Counter from './counter'
import DocumentTitle from './title'
import SelectTemplate from './selectTemplate'
import ContextAi from './contextAi'
import ExternalUser from './externalUser'
import AllowAddendums from './addendum'
import HasTermination from './termination'
import HasPreview from './hasPreview'
import SelectResponsibleTeam from './selectResponsibleTeam'
import TextareaDescription from './textareaDescription'
import { useSelector } from 'react-redux'

const Config = ({
	teamId,
	config,
	form,
	onTemplateChange,
	files,
	editor_text,
}) => {
	const handleTemplateChange = (value) => {
		onTemplateChange(value)
	}
	const session = useSelector(({ session }) => session)
	const hasDemands = session?.company?.config?.has_demands

	return (
		<>
			<SelectTemplate
				initial_template={config.templateType}
				onTemplateChange={handleTemplateChange}
				files={files}
				editor_text={editor_text}
			/>
			{hasDemands && <SelectResponsibleTeam initialTeam={teamId} />}
			<TextareaDescription initialDescription={config?.description} />
			<HasPreview initialHasPreview={config?.hasPreview} />
			<ContextAi initial_ContextAi={config.contextAi} />
			<AllowAddendums initialAllowAddendums={config.allowAddendums} />
			<HasTermination initialHasTermination={config.hasTermination} />
			<Counter counter={config.counter} />
			<DocumentTitle autoTitle={config.auto_title} />
			<ExternalUser externalUser={config.external_user} />
		</>
	)
}

Config.propTypes = {
	teamId: PropTypes.string,
	config: PropTypes.object,
	form: PropTypes.object,
	onTemplateChange: PropTypes.func,
	files: PropTypes.array,
	editor_text: PropTypes.string,
}

export default Config

export const configSelector = (form, templateType, team_id) => {
	const fieldValues = form.getFieldsValue()
	const selectedConfig = {
		counter: fieldValues.counter,
		auto_title: {
			enabled: fieldValues.autoTitleEnabled,
			components: fieldValues.components,
			separator: fieldValues.separator,
		},
		external_user: {
			enabled: fieldValues.externalUserEnabled,
			variable: fieldValues.externalUserVar,
		},
		templateType: templateType,
		contextAi: fieldValues.contextAi,
		allowAddendums: fieldValues.allowAddendums,
		hasTermination: fieldValues.hasTermination,
		hasPreview: fieldValues.hasPreview,
		description: fieldValues.description,
		team_id,
	}

	return selectedConfig
}
